import request from '@/utils/request'

// 获取招聘职位列表
export function getRecruitmentPositionList(params) {
  return request({
    url: '/recruitment-position',
    method: 'get',
    params
  })
}

// 添加招聘职位
export function createRecruitmentPosition(data) {
  return request({
    url: '/recruitment-position',
    method: 'post',
    data
  })
}

// 获取招聘职位详情
export function getRecruitmentPosition(id) {
  return request({
    url: `/recruitment-position/${id}`,
    method: 'get'
  })
}

// 编辑招聘职位
export function updateRecruitmentPosition(id, data) {
  return request({
    url: `/recruitment-position/${id}`,
    method: 'post',
    data
  })
}

// 删除招聘职位
export function deleteRecruitmentPosition(id) {
  return request({
    url: `/recruitment-position/${id}`,
    method: 'delete'
  })
}

// 批量删除招聘职位
export function batchDeleteRecruitmentPosition(ids) {
  return request({
    url: '/recruitment-position/batch-delete',
    method: 'post',
    data: { ids }
  })
}

// 获取场次选项
export function getSessionOptions() {
  return request({
    url: '/recruitment-position/session-options',
    method: 'get'
  })
}

export function getAllPositionList(params) { 
  return request({
    url: '/recruitment-position/all',
    params,
    method: 'get'
  })
}

// 复制招聘职位
export function copyRecruitmentPosition(id) {
  return request({
    url: `/recruitment-position/${id}/copy`,
    method: 'post'
  })
}

// 导出招聘职位列表
export function exportRecruitmentPositionList(params) {
  return request({
    url: '/recruitment-position/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 切换招聘职位状态
export function updateRecruitmentPositionStatus(id, data) {
  return request({
    url: `/recruitment-position/${id}/status`,
    method: 'post',
    data
  })
} 


// WEBPACK FOOTER //
// ./src/api/recruitment-position.js